module.exports = __webpack_public_path__ + "static/media/ldi-poster.492a9449.pdf";